import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { colors } from "utils";

// Shared prev/next CTA for the question carousels (live session pill modal and
// session-history "Session Questions"). Presentation only — the parent owns the
// navigation/data logic and passes the position label as children, so each
// context keeps its own wording (e.g. "Question 2 of 5" vs
// "Session Questions (2 of 5)").
//
// Accessibility is baked in here so both carousels share the same floor:
//   - real aria-labels on the buttons (chevron icons are decorative/aria-hidden)
//   - native `disabled` at the bounds (drops the button from the tab order)
//   - a visible :focus-visible ring for keyboard users
//   - aria-live="polite" on the label so SR users hear the position change
export const QuestionCarouselNav = ({
  onPrev,
  onNext,
  canPrev,
  canNext,
  prevLabel = "Previous question",
  nextLabel = "Next question",
  children,
}) => (
  <Nav>
    <NavButton type="button" onClick={onPrev} disabled={!canPrev} aria-label={prevLabel}>
      <FontAwesomeIcon icon={faChevronLeft} aria-hidden />
    </NavButton>
    <Position aria-live="polite">{children}</Position>
    <NavButton type="button" onClick={onNext} disabled={!canNext} aria-label={nextLabel}>
      <FontAwesomeIcon icon={faChevronRight} aria-hidden />
    </NavButton>
  </Nav>
);

export default QuestionCarouselNav;

const Nav = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

const NavButton = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: ${colors.nightlyWoods500};
  color: #ffffff;
  transition: background 120ms ease, color 120ms ease;
  &:disabled {
    background: #e5e7eb;
    color: #6b6967;
    cursor: not-allowed;
  }
  &:focus-visible {
    outline: 2px solid ${colors.blue500};
    outline-offset: 2px;
  }
`;

const Position = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
